import { Box, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemIcon, ListItemText, TextField, Typography } from "@mui/material";
import { UDialog, UDialogClose, UDialogCloseOnCompleteButton } from "../common/ui.dialog";
import { UnitComposition, useUnitComposition } from "./unit.composition";
import { URow } from "../common/ui.page";
import CheckIcon from '@mui/icons-material/Check';
import { useRef, useState } from "react";
import { UListItemButton } from "../common/ui.buttons";
import ClearIcon from '@mui/icons-material/Clear';
import { GREY, WHITE } from "../style/theme";
import { Add, Remove } from "@mui/icons-material";
import { UFieldset } from "../common/ui.fieldset";
import { UIcon } from "../common/ui.icon";

export function CEditComposition(props) {
    const { unit, ...rest } = props;
    const [edit, setEdit] = useState(unit.composition)

    return <UDialog fullScreen {...rest}>
        <DialogTitle>Modifica {unit.name}</DialogTitle>
        <DialogContent>
            <UnitComposition unit={unit} onChange={setEdit}>
                <CUnitEditor />
            </UnitComposition>
        </DialogContent>
        <DialogActions>
            <UDialogClose>Annulla</UDialogClose>
            <UDialogClose variant="contained" onClick={() => props.onChange(edit)}>Salva</UDialogClose>
        </DialogActions>
    </UDialog>
}

export function CUnitEditor() {
    const comp = useUnitComposition();
    return <List>
        {comp.upgrades.map(u => <EditorUpgrade key={u.id} upgrade={u} />)}
        {!comp.disableEditUpgrades && <EditorUpgradeNew />}
        {comp.models && <List>
            <ListItem>
                <Typography sx={{ color: WHITE, fontWeight: 600 }}>
                    Modelli
                </Typography>
            </ListItem>
            {comp.models.map(m => <EditorModel model={m} key={m.id} />)}
            {!comp.disableEditModels && <EditorModelNew />}
        </List>}
    </List>
}
function EditorModel(props) {
    const { model } = props;
    const comp = useUnitComposition(null, model);

    return <UFieldset title={model.name} sx={{ background: GREY[200] }}>
        <ListItem sx={{ position: 'relative' }} >
            <Box sx={{ position: 'absolute', left: -24, top: 10 }}>
                <UIcon size={32} name="unit" />
            </Box>
            <ListItemText primary={model.name} />

            <IconButton disabled={comp.disableEditModels} onClick={() => comp.reduceCount()} >
                <Remove />
            </IconButton>
            <Typography>{model.count}</Typography>
            <IconButton disabled={comp.disableEditModels} onClick={() => comp.increaseCount()} >
                <Add />
            </IconButton>
        </ListItem>
        {model.upgrades.map(u => <EditorUpgrade key={u.id} upgrade={u} model={model} />)}
        {!comp.disableEditUpgrades && <EditorUpgradeNew model={model} />}
    </UFieldset>
}
function EditorModelNew(props) {
    const { model } = props;
    const comp = useUnitComposition(null, model);
    const [name, setName] = useState('')

    function commitEdit() {
        if (name) {
            comp.addModel(name);
            setName('');
        }
    }

    return <ListItem>
        <TextField value={name}
            fullWidth
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    commitEdit()
                }
            }} onChange={e => setName(e.target.value)} size="small" label={"Aggiungi modello"} />
        {name.length > 0 && <IconButton onClick={commitEdit} disabled={name.length < 1}>
            <CheckIcon color="info" />
        </IconButton>}
    </ListItem>
}
function EditorUpgrade(props) {
    const { upgrade, model } = props;
    const comp = useUnitComposition(model, upgrade);

    return <UListItemButton disabled={comp.disableEditUpgrades} onClick={comp.remove}>
        <ListItemText primary={model ? '  ' + upgrade.name : upgrade.name} />
        <ClearIcon />
    </UListItemButton>
}
function EditorUpgradeNew(props) {
    const { model } = props;
    const comp = useUnitComposition(model);
    const [name, setName] = useState('')

    function commitEdit() {
        if (name) {
            comp.addUpgrade(name);
            setName('');
        }
    }

    return <ListItem>
        <TextField
            fullWidth
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    commitEdit()
                }
            }}
            value={name} onChange={e => setName(e.target.value)} size="small" label={"Aggiungi equipaggiamento"} />
        {name.length > 0 && <IconButton onClick={commitEdit} disabled={name.length < 1}>
            <CheckIcon color="info" />
        </IconButton>}
    </ListItem>
}

function CEditCompleteButton(props) {

    return
}